import { useState, useEffect } from "react";
import { fetchAPI } from "../utils/api";

// Hook especializado para APIs que usan estructura success/data
export const useFetchMedia = (endpoint, dependencies = []) => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!endpoint) return;

    const loadData = async () => {
      try {
        setLoading(true);
        setError(null);

        const result = await fetchAPI(endpoint);

        // Para APIs de media outlets, devolver el objeto completo
        // No extraer solo result.data, sino mantener toda la estructura
        setData(result);
      } catch (err) {
        setError(err.message);
        setData(null);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, [endpoint, ...dependencies]);

  return { data, loading, error };
};
